import styled from '@emotion/styled';

import { BREAKPOINTS } from '@/styles/themes/default';
import { IThemeProps } from '@/styles/themes/types';

import { Container } from '../core/Grid';
import { H3 } from '../core/Heading';

export const ContentContainer = styled(Container)<IThemeProps>`
  ${H3} {
    text-align: center;
    margin-bottom: 40px;
  }

  section {
    margin-bottom: 120px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    ${H3} {
      margin-bottom: 56px;
    }

    section {
      margin-bottom: 160px;
    }
  }
`;
